import PropTypes from 'prop-types';
// material
// import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object
};

export default function Logo({ sx }) {
  // const theme = useTheme();
  // const PRIMARY_LIGHT = theme.palette.primary.light;
  // const PRIMARY_MAIN = theme.palette.primary.main;
  // const PRIMARY_DARK = theme.palette.primary.dark;

  return (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        viewBox="0 0 100 100"
        style={{ enableBackground: 'new 0 0 100 100' }}
      >
        <polygon
          style={{ fill: '#593B8C' }}
          points="49.7,66.6 32.6,37.6 43.4,37.6 53.1,57.2 47.5,57 55.9,37.6 66.1,37.6 49.9,66.6 "
        />
      </svg>
    </Box>
  );
}
